import React, {useEffect} from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import {
    DataTable,
    DataTableBody,
    DataTableCell,
    DataTableColumnHeaderCell,
    DataTableContent,
    DataTableHeaderRow,
    DataTablePagination,
    DataTableRow,
    DataTableToolbar,
    TextButton,
} from "@episerver/ui-framework";
import {
    userAccountAssignmentsPaginationSelector,
    onChangeContactPage,
    onChangeContactRowPerPage,
} from "../reducers/userAccountAssignmentsReducer";
import { Contact, ContactType } from "../../ContactManager/model/contact";
import { useHistory } from "react-router-dom";
import { onChangeDialog } from "../reducers/addAssignmentsToUserReducer";
import { userAccountAssignmentsSelector } from "../reducers/userAccountAssignmentsReducer";
import { fetchUserAccountAssignments } from "../reducers/asyncThunks";

interface UserAccountAssignmentsProps {
    contactId: string;
    type: ContactType;
}

const UserAccountAssignments = (props: UserAccountAssignmentsProps) => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const Assignments = useSelector(userAccountAssignmentsSelector);
    const { rowsPerPage, startRow, rowsPerPageOptions, totalRowCount } = useSelector(
        userAccountAssignmentsPaginationSelector
    );

    useEffect(() => {
        dispatch(fetchUserAccountAssignments(props.contactId));
    }, []);

    const columns: Array<{ selector: string; title: string; sortable: boolean }> = props.type !== ContactType.Account ? [
        { selector: "FullName", title: "Full Name", sortable: true },
        { selector: "ContactCode", title: "Contact Code", sortable: true },
        { selector: "LastOrderDate", title: "Last Order Date", sortable: true },
        { selector: "CustomerGroup", title: "Customer Group", sortable: true },
    ] : [
        { selector: "FullName", title: "Full Name", sortable: true },
        { selector: "Email", title: "Email", sortable: true },
        { selector: "LastOrderDate", title: "Last Order Date", sortable: true },
        { selector: "CustomerGroup", title: "Customer Group", sortable: true },
    ];

    const renderRow = (rowData: Contact): React.ReactElement => {
        return (
            <DataTableRow rowId={rowData.primaryKeyId!} key={rowData.primaryKeyId}>
                <DataTableCell>
                    <a
                        href=""
                        className="underline-link"
                        onClick={(e) => {
                            e.preventDefault();
                            if (rowData.customerGroup === "Account") {
                                history.push({
                                    pathname: "/Accounts/Edit/" + rowData.primaryKeyId,
                                });
                            } else {
                                history.push({
                                    pathname: "/Users/Edit/" + rowData.primaryKeyId,
                                });
                            }
                        }}
                    >
                        {rowData.fullName}
                    </a>
                </DataTableCell>
                {props.type !== ContactType.Account && <DataTableCell>{rowData.extendedProperties?.find(property => property.name ==="ContactCode")?.value ?? ""}</DataTableCell>}
                {props.type === ContactType.Account && <DataTableCell>{rowData.email ?? ""}</DataTableCell>}
                <DataTableCell>
                    {rowData.lastOrder != null ? new Date(rowData.lastOrder).toLocaleDateString() : ""}
                </DataTableCell>
                <DataTableCell>{rowData.customerGroup ?? ""}</DataTableCell>
            </DataTableRow>
        );
    };

    return (
           <div className="child-organization-list">
            {
            console.log(Assignments)}
            <DataTable>
                <DataTableToolbar className="child-organization-list__toolbar">
                    <div>
                        <TextButton
                            onClick={() =>
                                dispatch(
                                    onChangeDialog({
                                        open: true,
                                    })
                                )
                            }
                        >
                            Update
                        </TextButton>
                    </div>
                </DataTableToolbar>
                <DataTableContent>
                    <DataTableHeaderRow>
                        <React.Fragment>
                            {columns.map((column) => {
                                return (
                                    <DataTableColumnHeaderCell key={column.selector}>
                                        {column.title}
                                    </DataTableColumnHeaderCell>
                                );
                            })}
                        </React.Fragment>
                    </DataTableHeaderRow>
                    <DataTableBody>
                        {Assignments.map((row: Contact, index: number) => {
                            if (index < startRow || index >= startRow + rowsPerPage) {
                                return <React.Fragment key={row.primaryKeyId}></React.Fragment>;
                            }
                            return renderRow(row);
                        })}
                    </DataTableBody>
                </DataTableContent>
                <DataTablePagination
                    startRow={startRow}
                    totalRowCount={totalRowCount}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={rowsPerPageOptions}
                    onChangePage={(startRow) => dispatch(onChangeContactPage(startRow))}
                    onChangeRowsPerPage={(rowsPerPage) => dispatch(onChangeContactRowPerPage(rowsPerPage))}
                />
            </DataTable>
        </div>
    );
};

export default UserAccountAssignments;
